import React, { Component } from "react";
import PropTypes from "prop-types";
import ComparableGrid from "components/Homeowner/CaseForms/ComparableGrid/ComparableGrid";

class CompSearch extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <ComparableGrid controlNumber={this.props.controlNumber} readOnly />;
    }
}

CompSearch.propTypes = {
    form: PropTypes.object.isRequired,
    controlNumber: PropTypes.string.isRequired
};

export default CompSearch;